/**
 * 通用 API 响应类型
 * @template T 响应数据的类型
 */
export interface R<T = any> {
  /** 响应码 */
  code?: number;
  /** 响应消息 */
  msg?: string;
  /** 响应数据 */
  data: T;
}

export interface PageR<T = any> extends R<{
  records: T[];
  total: number;
  size: number;
  current: number;
}> {
}

export enum BuyerRegisterTypeEnum {
  PHONE = 'MOBILE',
  EMAIL = 'EMAIL',
  WECHAT = 'WECHAT',
}


export enum ChannelTypeEnum {
  MINI = 'MINI',
  H5 = 'H5',
  WEB = 'WEB',
  APP = 'APP',
}

export enum PlatformEnum {
  ALL = '',
  PLATFORM = 'PLATFORM',
  JAPANMALL = 'JAPANMALL',
  VIP = 'VIP',
  SGW = 'SGW',
}

export enum OrderStatusEnum {
  ALL = '0',
  PROCESSING = '1',
  COMPLETED = '2',
  CANCELLED = '3',
}

export enum CateringCategoryCodeEnum {
  FOOD = 'FOOD',
  SHOPPING = 'SHOPPING',
  ENTERTAINMENT = 'ENTERTAINMENT',
  TRANSPORT = 'TRANSPORT',
}

/**
 * 操作类型枚举
 */
export enum BuyerOperationTypeEnum {
  /** 注册 */
  REGISTER = 'register',
  /** 登录 */
  LOGIN = 'login',

}

/**
 * 注册来源枚举（对应平台枚举）
 */
export enum BuyerRegisterSourceEnum {
  /** 平台 */
  PLATFORM = 1,
  /** 日本商城 */
  JAPANMALL = 2,
  /** VIP */
  VIP = 3,
  /** 佐川物流 */
  SGW = 4,
}

export enum BookCarTypeEnum {
  /** 经济型轿车 */
  'economy_car' = 'economy_car',
  /** 商务轿车 */
  'business_car' = 'business_car',
  /** 豪华SUV */
  'luxury_suv' = 'luxury_suv',
  /** 7座MPV */
  'SEVEN_SEATER_MPV' = 'SEVEN_SEATER_MPV',
}